import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Stars, Sparkles } from 'lucide-react';

const Footer: React.FC = () => {
    return (
        <div className="px-6 py-16 flex flex-col items-center justify-center">
            <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                className="max-w-2xl w-full text-center"
            >
                <motion.div
                    animate={{ rotate: 360 }}
                    transition={{ repeat: Infinity, duration: 25, ease: "linear" }}
                    className="text-primary-red mb-6 opacity-10 flex justify-center"
                >
                    <Stars size={80} />
                </motion.div>

                <h2 className="text-3xl md:text-4xl font-playfair font-bold text-primary-red mb-6 leading-tight">
                    Forever & Always ❤️
                </h2>

                <div className="bg-primary-red/5 dark:bg-primary-red/10 p-8 rounded-[2.5rem] border border-primary-red/5 mb-10">
                    <p className="text-lg md:text-xl font-poppins text-gray-700 dark:text-gray-200 leading-relaxed italic opacity-80">
                        "50 days is just the prologue of our infinite story. I can't wait to write the rest of the chapters with you."
                    </p>
                </div>

                <div className="flex flex-col items-center mb-12">
                    <p className="font-playfair font-bold text-lg text-primary-red mb-2 opacity-60">With Love,</p>
                    <div className="flex items-center space-x-2 text-primary-red">
                        <motion.div animate={{ scale: [1, 1.1, 1] }} transition={{ repeat: Infinity, duration: 1.5 }}>
                            <Heart fill="currentColor" size={24} />
                        </motion.div>
                        <span className="text-xl font-bold font-playfair tracking-wide">Yours Forever ❤️</span>
                    </div>
                </div>

                <div className="flex justify-center space-x-4 mb-8">
                    <Sparkles size={16} className="text-yellow-400 opacity-50" />
                    <Sparkles size={16} className="text-yellow-400 opacity-50" />
                    <Sparkles size={16} className="text-yellow-400 opacity-50" />
                </div>

                <p className="text-[8px] text-gray-400 uppercase tracking-[0.4em] font-bold">
                    Day 50 of forever
                </p>
            </motion.div>
        </div>
    );
};

export default Footer;
